import React from "react";

const AuthContainer = ({ children }: { children: React.ReactNode }) => (
  <div className="auth-page-content">{children}</div>
);

export default React.memo(AuthContainer);
